import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Item } from "../item";
import { LegalDateTimeService } from 'src/app/services/legal-datetime.service';
@Component({
  selector: 'app-todo-item',
  templateUrl: './todo-item.component.html',
  styleUrls: ['./todo-item.component.css']
})





export class TodoItemComponent {

  editable = false;

  @Input() item: Item;
  @Input() newItem: string;
  @Output() remove = new EventEmitter<Item>();
  @Output() save = new EventEmitter<Item>();

  constructor(private legalDate: LegalDateTimeService) {}

  formatAuditDate(value: unknown): string {
    return this.legalDate.formatAudit(value as string | number | Date | null | undefined, 'DD/MM/YYYY h:mm a');
  }

  saveItem(description) {
    if (!description) return;
    this.editable = false;
    this.item.description = description;
    this.save.emit(this.item);
  }

// check box function
public checkDone(value:any, item) {

console.log('valeu checked: ' + value);

let getVal = value;
let newvalue;

if(getVal === false) {
  this.item.done = 'true';
  newvalue = 'false';
  // alert('Item is false');
}
if(getVal === true) {
  this.item.done = 'false';
  // alert('Item is false');
  newvalue = 'true';
};

this.item.done = newvalue;
console.log('this.item.done value: ' + this.item.done);
this.save.emit(this.item);

}


}








// export class TodoItemComponent implements OnInit {

//   editable = false;

//   @Input() item: Item;
//   @Input() newItem: string;
//   @Output() remove = new EventEmitter<Item>();


//   constructor() { }

//   ngOnInit() {
//   }

  
//   saveItem(description) {
//     if (!description) return;
//     this.editable = false;
//     this.item.description = description;
//   }

// }
